import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

declare let $: any;

@Component({
    selector: 'dashboard',
    template: require('./dashboard.component.html'),
    styles: [require('./dashboard.component.css')]
})
export class DashboardComponent implements OnInit, AfterViewInit {
    public routerEvent: any;

    constructor(
        private router: Router,
        private route: ActivatedRoute) {
        router.events.subscribe((data) => {
            this.routerEvent = data;
        });
    }

    public ngOnInit(): void {
        // console.log($);
    }

    public ngAfterViewInit(): void {
        // console.log($);
    }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/dashboard/dashboard.component.ts